import { Switch } from 'react-router-dom';
import { Route } from 'react-router';

import { UserActivityTable } from './user-activity/table';
import Error404 from '../errors/404';
import { EquipmentsScanningTable } from './equipments-scanning/table';
import { ActivitiesMap } from './activities-map/map';
import { StandsReportTable } from './stands/table';
import { EquipmentsTransactionsTable } from './transactions/table';
import { ActivitiesGallery } from './activities-gallery/gallery';
import { DmpsReportTable } from './dmp/table';


const ReportsPage = () => {
  return (
    <Switch>
      <Route
        exact
        path="/reports/user-activity"
        component={UserActivityTable}
      /> 
      <Route
        exact
        path="/reports/scanning"
        component={EquipmentsScanningTable}
      /> 
      <Route
        exact
        path="/reports/transactions"
        component={EquipmentsTransactionsTable}
      /> 
      <Route
        exact
        path="/reports/activities-map"
        component={ActivitiesMap}
      /> 
      <Route
        exact
        path="/reports/stands"
        component={StandsReportTable}
      />
      <Route
        exact
        path="/reports/dmp"
        component={DmpsReportTable}
      />
      <Route
        exact
        path="/reports/activities-gallery"
        component={ActivitiesGallery}
      /> 
      <Route path="*" component={Error404} />
    </Switch>
  );
};

export default ReportsPage;
